export default {
  au: {
    title: 'Westfield Australia',
    meta: [
      {
        name: 'description',
        content:
          "Find thousands of products from your favourite retailers across women's and men's fashion, kids, home and decor and more.",
      },
      { name: 'keywords', content: 'sample, something' },
    ],
    lang: 'en-AU',
  },
  nz: {
    title: 'Westfield New Zealand',
    meta: [
      {
        name: 'description',
        content:
          "Find thousands of products from your favourite retailers across women's and men's fashion, kids, home and decor and more.",
      },
      { name: 'keywords', content: 'sample, something' },
    ],
    lang: 'en-NZ',
  },
}
